<template>
  <div>
    <b-form-checkbox
      v-model="data"
      :disabled="disabled"
      name="check-button"
      switch
    />
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  components: {
    BFormCheckbox,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  computed: {

  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
